import classNames from "classnames";
import React, { JSX } from "react";

import { ActivityStatusBadge, ActivityStatusBadgeProps } from "./activity_status_badge";
import css from "./audit_role_status.module.scss";
import { AuditRoleStatusBadge } from "./audit_role_status_badge";

type AuditRoleStatusProps = {
  role: { state: string; workflow_state: string };
  className?: string;
  withStateBadge?: boolean;
  withWorkflowStateBadge?: boolean;
  classes?: {
    root?: string;
    workflowStateBadge?: string;
  };
  activityStatusBadgeClasses?: ActivityStatusBadgeProps["classes"];
};

export const AuditRoleStatus = ({
  role,
  className,
  withStateBadge = true,
  withWorkflowStateBadge = true,
  classes = {},
  activityStatusBadgeClasses
}: AuditRoleStatusProps): JSX.Element | null => {
  if (!withStateBadge && !withWorkflowStateBadge) {
    return null;
  }
  return (
    <div className={classNames(css.root, classes.root)}>
      {withStateBadge && (role.state === "draft" || role.state === "complete") && (
        <ActivityStatusBadge status={role.state} classes={activityStatusBadgeClasses} />
      )}
      {withWorkflowStateBadge && (
        <AuditRoleStatusBadge
          status={role.workflow_state}
          className={classNames(className, classes.workflowStateBadge)}
        />
      )}
    </div>
  );
};
